import { useState } from 'react';
import { Link } from 'react-router-dom';

import companyLogo from '../assets/images/logo-audpro.png';
import productLogo from '../assets/images/logo.png';
import { IoIosSearch } from 'react-icons/io';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className='bg-primary'>
      <nav className='relative container mx-auto p-6'>
        <div className='flex items-center justify-between'>
          <div className='flex flex-row gap-2 items-center'>
            <img src={companyLogo} alt='' className='w-10' />
            <p className='text-2xl font-bold'>AuditPro</p>
          </div>
          <div className='hidden space-x-6 md:flex'>
            <a href='#features' className='hover:text-orange-600'>
              Benficios
            </a>
            <a href='#auditPro' className='hover:text-orange-600'>
              Como funciona?
            </a>
            <Link to='https://hotlinetecnologia.com.br' className='hover:text-orange-600' target='_blank' rel='noopener noreferrer'>
              Site hotline
            </Link>
          </div>
          {/* <Link
            to='/classificacao-tributaria'
            className='hidden p-3 md:flex flex-row! items-center gap-2 px-6 pt-2 text-white bg-brightRed rounded-full baseline hover:bg-brightRedLight'
          >
            <IoIosSearch />
            <p>Consulte agora</p>
          </Link> */}
          <div>
            <div className='pt-2'>
              <img src={productLogo} alt='' className='w-20' />
            </div>
          </div>
          <button
            className={
              toggleMenu
                ? 'open block hamburger md:hidden focus:outline-none'
                : 'block hamburger md:hidden focus:outline-none'
            }
            onClick={() => setToggleMenu(!toggleMenu)}
          >
            <span className='hamburger-top'></span>
            <span className='hamburger-middle'></span>
            <span className='hamburger-bottom'></span>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className='md:hidden'>
          <div
            className={
              toggleMenu
                ? 'absolute flex flex-col items-center self-end py-8 mt-10 space-y-6 font-bold bg-white sm:w-auto sm:self-center left-6 right-6 drop-shadow-md'
                : 'absolute flex-col items-center hidden self-end py-8 mt-10 space-y-6 font-bold bg-white sm:w-auto sm:self-center left-6 right-6 drop-shadow-md'
            }
          >
            <Link to='#'>Pricing</Link>
            <Link to='#'>Product</Link>
            <Link to='#'>About Us</Link>
            <Link to='#'>Careers</Link>
            <Link to='#'>Community</Link>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
